const {
	DASHBOARD_PATH,
	LEGAL_DASHBOARD_PATH,
	DEALS_DASHBOARD_PATH,
	PRELIMINARY_DASHBOARD_PATH,
	RM_PATH,
	INAB_PATH,
	PLAY_GROUND,
	PROJECTS,
	RG_PATH,
	MY_PROFILE_PATH
} = {
	DASHBOARD_PATH: "/dashboard",
	LEGAL_DASHBOARD_PATH: "/legal-dashboard",
	DEALS_DASHBOARD_PATH: "/deal-review-dashboard",
	PRELIMINARY_DASHBOARD_PATH: "/scoped-dashboard",
	RM_PATH: "/rm",
	INAB_PATH: "/inab",
	PLAY_GROUND: "/playground",
	PROJECTS: `/projects`,
	RG_PATH:"reports",
	MY_PROFILE_PATH:`/my-profile`
};

const PageConfig = {
	DASHBOARD: DASHBOARD_PATH,
	LEGAL: {
		LEGAL_DASHBOARD: LEGAL_DASHBOARD_PATH,
		OVERVIEWPROJECT: "/legal-over-view",
		SOWGENERATE: "/sow-generation",
		SOWUPLOAD: "/sow-upload",
		LEGALDOWNLOAD: "/sow-download",
		FINALREVIEW: "/sow-review",
		INPROCESS:"/legal-inprocess",
		LEGALCOMPLETE: "/legal-complete",
		LEGALQUESTIONNAIRE: "/deal-review-dashboard/legal-questionnaire",
		LEG_DEAL_LOST:'/legal-deallost'
	},
	DEALS: {
		DEALREVIEWDASHBOARD: DEALS_DASHBOARD_PATH,
		OVERVIEWPROJECT: "/over-view-project",
		DEALREVIEW: "/deal-review",
		REVIEWANDAPPROVAL: "/review-and-approval",
		ALLDEALREVIEW: "/deal-review-dashboard/all-deal-review",
		LEGALQUESTIONNAIRE: "/legal-pending",
		VERSIONCREATION: "/version-creation",
	},
	DEALREVIEW: {
		OVERVIEWPROJECT: "/over-view-project",
		FINALREVIEW: "/final-review",
		DR_DEAL_LOST: '/deal-review-deallost',
		DR_COMPLETE:'/deal-review-complete'
	},
	PROFILE: {
        MYPROFILE:'/profile'
	},
	PLAYGROUND: {
		PLAYGROUND:PLAY_GROUND,
        WORKSHEETS:`${PLAY_GROUND}/worksheets`,
		CURRENTWORKINGWORKSHEET:`${PLAY_GROUND}/current-worksheet`,
		ADDWORKSHEET:`${PLAY_GROUND}/add-worksheet`,
		PROJECTS: `${PLAY_GROUND}/projects`,
	},
	RM: {
		RMDASHBOARD: `${RM_PATH}/rm-dashboard`,
		PEOPLELANDING: `${RM_PATH}/peoplelanding`,
		RMLANDING: `${RM_PATH}/rmlanding`,
		ADDEMPLOYEE: `${RM_PATH}/peoplelanding/add-employee`,
		PROFILE: `${RM_PATH}/peoplelanding/profile`,
		
		PRoJECTSOVERVIEW: `/project-details`,
		INABPROJECTSOVERVIEW: `/inab-details`,
		PROJECTHOME: `${RM_PATH}/resource-allocation-dashboard`,
		RESOURCEALLOCTION: `/resource-allocation-dashboard/resource-allocation`,
		INABALLOCATON: `/resource-allocation-dashboard/inab-resource-allocation`,
		RESOURCEALLOCTIONFACT: `/resource-allocation-dashboard/resource-allocation/resource-allocation-fact`,
		INABRESOURCEALLOCTIONFACT: `/resource-allocation-dashboard/inab-resource-allocation/resource-allocation-fact`,
		RESOURCEALLOCTIONFACTREVIEW: `/resource-allocation-dashboard/resource-allocation/resource-allocation-fact/review`,
		RESOURCEALLOCTIONFACTPARTIALALLOCATION: `/resource-allocation-dashboard/resource-allocation/resource-allocation-fact/partial-allocation`,
		INABRESOURCEALLOCTIONFACTREVIEW: `/resource-allocation-dashboard/inab-resource-allocation/resource-allocation-fact/review`,
		PRELIMINARY: `/resource-allocation-dashboard/pre-staffing-overview`,
		REVIEW: `${RM_PATH}/preliminarystaffingreview`,
		DEMANDPIPELINE: `${RM_PATH}/demandpipeline`,
		PROJECTDEMAND:`${RM_PATH}/demandpipeline/project-demand`,
		OTHERDEMAND:`${RM_PATH}/demandpipeline/other-demand`,
		PRELIMINARYSTAFFINGDEMAND:`${RM_PATH}/demandpipeline/preliminary-staffing`,
	},
	RG: {
        RGBench: `${RM_PATH}/${RG_PATH}/benchforecast`,
		RGRMSheet: `${RM_PATH}/${RG_PATH}/rmsheet`,
		RGDemandResources: `${RM_PATH}/${RG_PATH}/demandforecast`,
		RGDemandResourcesPROFILE: `${RM_PATH}/${RG_PATH}/demandforecast/profile`,
		RGBENCHPROFILE: `${RM_PATH}/${RG_PATH}/benchforecast/profile`,
		RGRMSHEETPROFILE: `${RM_PATH}/${RG_PATH}/rmsheet/profile`,
		RGGlobalAvailability: `${RM_PATH}/${RG_PATH}/globalavailability`,
		RGGlobalAvailabilityBenchManagement: `${RM_PATH}/${RG_PATH}/globalavailability/benchmanagement`
	},
	PRELIMINARY: {
		DASHBOARD: PRELIMINARY_DASHBOARD_PATH,
		OVERVIEW: "/scoped-overview",
		REVIEW: "/scoped-review",
	},
	ADMIN: {
		DASHBOARD: "/admin/admin-dashboard",
		RBAC: "/admin/access-policy",
		CREATE_ACCESS_POLICY:"/admin/access-policy/create-access-policy",
		EDIT_ACCESS_POLICY:"/admin/access-policy/edit-access-policy",
		RBACRATECARD: "/admin/ratecard",
		NOTIFICATION: "/admin/notification",
		SKILLSANDCERTIFICATION: "/admin/skills-and-certification"
	},
	INAB: {
		DASHBOARD: INAB_PATH,
		NEWSUBMISSION: INAB_PATH+"/new-submission",
		REVIEWANDAPPROVAL: INAB_PATH+"/review-and-approval",
		SUBMITFORRM: INAB_PATH+"/submit-for-rm",
		PLAINREVIEWANDAPPROVAL:"/inab-review-and-approval",
		PLAINSUBMITFORRM:"/submit-for-rm"
	},
	// Add more pages as needed
	SOW_DOWNLOAD: "sow-download",
	LEGAL_DASHBOARD: "legal-dashboard",
	SOW_REVIEW: "sow-review",
	SOW_GENERATION: "sow-generation",

	LABEL_SOW_DOWNLOAD: "SOW-download",
	LABEL_DASHBOARD: "dashboard",
	LABEL_SOW_GENERATION: "SOW-generation",
	LABEL_SOW_REVIEW: "SOW_REVIEW",

	BUTTON_REVIEW: "Submit for Review",
	BUTTON_CUST_REV: "Submit for Customer Review",
	BUTTON_RM: "Submit for Resource Management",
	BUTTON_DR: "Submit for Deal Review",

	//Legal Details Slice Page
	FETCH_LEGAL: "legalDetails/fetchLegalDetails",

	ERROR_SNACKBAR: "error",
	SUCCESS_SNACKBAR: "success",
	
	DEAL_LOST:'/lost-deals',
};

const getParentPath = () => {
	const url = new URL(window.location.pathname, window.location.origin);
	const parentPath = "/"+url.pathname.split("/").slice(1, 2).join("");
	return parentPath;
};


export {
	PageConfig, DASHBOARD_PATH, LEGAL_DASHBOARD_PATH, DEALS_DASHBOARD_PATH,
	PRELIMINARY_DASHBOARD_PATH, RM_PATH, INAB_PATH, getParentPath, PROJECTS, MY_PROFILE_PATH
};